var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex justify-space-around" },
    [
      _c("custom-technician-chips", {
        attrs: {
          label: _vm.generateMessage(
            "properties_360.fields.mnt_responsible_technician"
          ),
          technician: _vm.mntResponsibleTech,
          loading: _vm.loading
        },
        on: {
          click: function($event) {
            return _vm.$emit("click", _vm.mntResponsibleTech)
          }
        }
      }),
      _vm._v(" "),
      _c("custom-technician-chips", {
        attrs: {
          label: _vm.generateMessage("properties_360.fields.mnt_resp_buddy"),
          technician: _vm.mntResponsibleTechBuddy,
          loading: _vm.loading
        },
        on: {
          click: function($event) {
            return _vm.$emit("click", _vm.mntResponsibleTechBuddy)
          }
        }
      }),
      _vm._v(" "),
      _c("custom-technician-chips", {
        attrs: {
          label: _vm.generateMessage(
            "properties_360.fields.maintenance.tech_in_charge"
          ),
          loading: _vm.loading,
          technician: _vm.techInCharge
        },
        on: {
          click: function($event) {
            return _vm.$emit("click", _vm.techInCharge)
          }
        }
      }),
      _vm._v(" "),
      _c("custom-technician-chips", {
        attrs: {
          label: "Astreinte",
          loading: _vm.loading,
          technician: _vm.firstOnCall
        },
        on: {
          click: function($event) {
            return _vm.$emit("click", _vm.firstOnCall)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }